import { useState } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { errMsg } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";

export default function LoginPage() {
  const { user, login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  if (user && user !== false) return <Navigate to="/" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-background text-foreground grid lg:grid-cols-2">
      <div className="flex items-center justify-center p-8">
        <form onSubmit={submit} className="w-full max-w-sm" data-testid="login-form">
          <div className="font-heading font-black text-3xl tracking-tighter mb-1">
            LEO'S<span className="text-[#FF3B30]">FLEET</span>
          </div>
          <p className="text-muted-foreground text-sm mb-10">Fleet command centre — sign in to continue.</p>
          <div className="space-y-5">
            <div>
              <Label className="uppercase text-xs tracking-[0.2em] font-bold text-muted-foreground">Email</Label>
              <Input
                data-testid="login-email-input"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="mt-2 rounded-none bg-card border-border h-11"
                placeholder="transport@leosfood.com"
              />
            </div>
            <div>
              <Label className="uppercase text-xs tracking-[0.2em] font-bold text-muted-foreground">Password</Label>
              <Input
                data-testid="login-password-input"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="mt-2 rounded-none bg-card border-border h-11"
                placeholder="••••••••"
              />
            </div>
            {error && (
              <div data-testid="login-error" className="text-[#FF3B30] text-sm border border-[#FF3B30]/40 bg-[#FF3B30]/10 px-3 py-2">
                {error}
              </div>
            )}
            <Button
              data-testid="login-submit-button"
              type="submit"
              disabled={loading}
              className="w-full h-11 rounded-none bg-[#FF3B30] hover:bg-[#ff554b] text-white font-bold uppercase tracking-widest text-xs"
            >
              {loading ? "Signing in…" : "Sign in"}
            </Button>
          </div>
        </form>
      </div>
      <div className="hidden lg:block relative">
        <img
          src="https://images.unsplash.com/photo-1591768793355-74d04bb6608f?crop=entropy&cs=srgb&fm=jpg&q=85"
          alt="Fleet trucks on highway"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-black/60" />
        <div className="absolute bottom-10 left-10 right-10">
          <div className="font-heading font-black text-4xl tracking-tighter leading-tight text-white">
            Every vehicle.<br />Every inspection.<br />
            <span className="text-[#FF3B30]">One command centre.</span>
          </div>
        </div>
      </div>
    </div>
  );
}
